<template>
  <div class="select-util" v-if="configType">
    <el-select v-model="value" :multiple="mutiple" size="mini"
      :popper-class="popperClass"
      :style="`width:${width};`"
      @change="handleSelect" @focus="changeState" @blur="changeState" :disabled="able ? false : true">
      <el-option 
        name="option"
        v-for="(item,index) in list" :key="index"
        :label="item[labelKey]"
        :value="item[valueKey]"
        :disabled="item[ableKey] === 1 ? true : false">
      </el-option>
    </el-select>
  </div>  

  
</template>
<script>
const config = {
  teamer: {
    listFn: 'getTeamerList',
    listName: 'teamers',
    module: 'Organize',
    mapName: 'teamerMap',
    label: 'nickName',
    value: 'userId'
  },
  role: {
    listFn: 'getRoleList',
    listName: 'roleList',
    module: 'Role'
  },
  permission: {
    listFn: 'getPermissionList',
    listName: 'permissions',
    module: 'Permission'
  },
  assign: {
    listFn: 'getDepartAssignList',
    listName: 'departAssignList',
    module: 'Organize'
  },
  cusLevel: {
    listFn: 'getCustomerLevels',
    listName: 'cusLevels',
    module: 'Customer',
    label: 'name',
    value: 'name'
  },
  template: {
    listFn: 'getTemplateList',
    listName: 'templateList',
    module: 'Subject',
    value: 'subjectId'
  },
  handover:{
    listFn: 'getHandoverMethodList',
    listName:'handoverMethod',
    module:'Contract',
  },
  serviceName:{
    listFn: 'getServiceNameList',
    listName:'serviceName',
    module:'Contract'
  },
  paymentMethod:{
    listFn: 'getPaymentMethodList',
    listName:'PaymentMethodList',
    module:'Contract'
  },
  customerType:{
    listFn:'getCustomerTypeList',
    listName:'customerTypeList',
    module:'Customer',
    label:'name',
    value:'value'
  }
}
export default {
  props: {
    popperClass: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required:true
    },
    form: {
      type: Object,
      default: () => {},
      required:true
    },
    k: {
      type: String,
      default: 'teamer',
      required: true
    },
    mutiple: {
      type: Boolean,
      default: false
    },
    state: {
      type: Object,
      default: () => {}
    },
    customize: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'mini'
    },
    width: {
      type: String,
      default: '180px'
    },
    ableKey: {
      type: String,
      default: 'hasDept'
    },
    able: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      value: ''
    }
  },
  computed: {
    configType() {
      return config[this.type]
    },
    list() {
      return this.$store.state[this.configType.module][this.configType.listName]
    },
    map() {
      return this.$store.state[this.configType.module][this.configType.mapName]
    },
    labelKey() {
      if(this.configType.label) {
        return this.configType.label
      }else {
        return 'name'
      }
    },
    valueKey() {
      if(this.configType.value) {
        return this.configType.value
      }else {
        return 'id'
      }
    }
  },
  created(){
    if (!this.configType) return
    this.getList()
    this.initValue()
  },
  methods: {
    getList() {
      this.$store.dispatch(this.configType.listFn)
    },
    handleSelect(e) {
      this.form[this.k] = e
      this.$emit('send',this.form)
    },
    changeState() {
      if(this.customize) this.$emit( 'stateCB' , this.k)
    },
    initValue() { 
      if(typeof this.form[this.k] === 'string' | typeof this.form[this.k] === 'number') {
        this.value = this.form[this.k]
      } else if(Object.prototype.toString.call(this.form[this.k]) === '[object Array]') {
        const value = []
        this.form[this.k].forEach(id => value.push(id))
        this.value = value
      } else {
        this.value = ''
      }
    }
  },
  watch: {
    form(nV) {
      this.initValue()
    }
  }
}
</script>
<style lang="scss">
.select-util {
  .el-input.is-disabled .el-input__inner {
    background: #fff;
    color: #606266 !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Util/SelectUtil.vue